export function ClubCrest({ club, size = 44 }) {
  const primary = club?.color_primary || "#E5B842";
  const secondary = club?.color_secondary || "#0f0f0f";
  const initials = (club?.short_name || club?.name || "?")
    .replace(/[^A-Za-z]/g, "")
    .slice(0, 4)
    .toUpperCase();
  return (
    <div
      data-testid="club-crest"
      className="flex items-center justify-center rounded-lg font-heading font-extrabold shrink-0 border border-white/10 shadow-inner"
      style={{
        width: size,
        height: size,
        background: `linear-gradient(135deg, ${primary} 0%, ${primary} 55%, ${secondary} 55%, ${secondary} 100%)`,
        fontSize: size * 0.32,
        color: "#fff",
        textShadow: "0 1px 2px rgba(0,0,0,0.6)",
      }}
    >
      {initials}
    </div>
  );
}
